import { useEffect, useState } from "react";

export default function usePagination(
	totalRecords: number,
	perPageCount: number,
	currentPage: number,
	reset: boolean,
) {
	const [pageStart, setPageStart] = useState(1);
	const [pageEnd, setPageEnd] = useState(10);
	const [noOfPages, setNoOfPages] = useState(10);
	const [current, setCurrent] = useState(currentPage);

	useEffect(() => {
		setPageStart(1);
		setPageEnd(10);
		setCurrent(1);
	}, [reset]);

	useEffect(() => {
		let currentNumberOfPages = Math.ceil(totalRecords / perPageCount);
		let currentRecCount = (current - 1) * perPageCount;
		let currentPageStart = current === 1 ? current : currentRecCount + 1;
		let currentPageEnd =
			currentPageStart + perPageCount > totalRecords
				? totalRecords
				: currentPageStart + (perPageCount - 1);
		setPageStart(currentPageStart);
		setPageEnd(currentPageEnd);
		setNoOfPages(currentNumberOfPages);
	}, [totalRecords, current]);

	const nextPage = (page: number) => {
		setCurrent(page - 1);
	};

	const previousPage = (page: number) => {
		setCurrent(page + 1);
	};

	const moveFirst = () => {
		setCurrent(1);
	};

	const moveLast = (end: number) => {
		setCurrent(end);
	};

	const moveTo = (page: number) => {
		setCurrent(page);
	};

	return {
		pageStart,
		pageEnd,
		noOfPages,
		current,
		nextPage,
		previousPage,
		moveFirst,
		moveLast,
		moveTo,
	};
}
